var body = document.querySelector('body');
var header = document.querySelector('header');
var CD = document.querySelector('.cart-drawer');
var NM = document.querySelector('.nav-mobile');

console.log('%c                                                                     ', 'background-color: #030614; padding: 12px 40px');
console.log('%cThis website has been designed by                   ','background-color: #030614; color: #fff; font-size: 20px; padding: 12px 40px 12px 40px; font-family: "Montserrat", sans-serif; font-weight: 500;');
console.log('%cCINARIA                                ','background-color: #030614; color: #37c8ae; font-size: 32px; padding: 12px 40px 12px 40px; font-family: "Montserrat", sans-serif; font-weight: 900;');
console.log('%cContact us for a free quote :                                                      ','background-color: #030614; color: #fff; font-size: 16px; padding: 12px 40px 12px 40px; font-family: "Montserrat", sans-serif; font-weight: 500;');
console.log('%cadmin@cinaria.fr                                                                       ','background-color: #030614; color: #fff; font-size: 16px; padding: 12px 40px 12px 40px; font-family: "Montserrat", sans-serif; font-weight: 600;');
console.log('%c                                                                     ', 'background-color: #030614; padding: 12px 40px');

// --- Nav mobile functions ------------------------------------
function toggleNM() {
    if (isActive(NM)) closeNM();
    else openNM();
}
function openNM() {
    setActive(NM);
    cartDrawer.close();
    body.classList.add('menu-open','from-left');
}
function closeNM() {
    unsetActive(NM);
    body.classList.remove('menu-open','from-left');
    var nmMega = document.querySelector('.nav-mobile-mega');
    if(nmMega){
        nmMega.querySelector('.nm-inner').classList.remove('lvl1', 'lvl2', 'lvl3');
        nmMega.querySelector('.nm-inner').classList.add('lvl1');
        document.querySelectorAll('.nm-menu-sub').forEach((el) => unsetActive(el));
        document.querySelectorAll('.nm-menu-subsub').forEach((el) => unsetActive(el));
    }
}

function debounce(func, delay) {
    let timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func();
      }, delay);
    };
}

document.addEventListener('DOMContentLoaded', function () {

    const handleResize = debounce(getHeaderH, 200);
    window.addEventListener('resize', handleResize);

    class selector extends HTMLElement {
        constructor() {
            super();
            this.selectors = this.getElementsByClassName('selector-selector');
            this.contents = this.getElementsByClassName('selector-content');
            if (this.selectors.length > 1) {
                for (let i = 0; i < this.selectors.length; i++) {
                    this.selectors[i].addEventListener('click', this.switchContent.bind(this));
                }
            }
        }
        switchContent(e) {
            if (e.target.classList.contains('selector-selector')) var eTarget = e.target;
            else eTarget = e.target.closest('.selector-selector');
            var pos = parseInt(eTarget.getAttribute('selector-pos'));
            for (i = 0; i < this.selectors.length; i++) {
                if (this.selectors[i].getAttribute('selector-pos') == pos) setActive(this.selectors[i]);
                else unsetActive(this.selectors[i]);
            }
            for (i = 0; i < this.contents.length; i++) {
                if (this.contents[i].getAttribute('selector-pos') == pos) setActive(this.contents[i]);
                else unsetActive(this.contents[i]);
            }
        }
    }
    customElements.define('selector-xx', selector);
    class nav extends HTMLElement {
        constructor() {
            super();
            this.elsWithDropdown = this.getElementsByClassName('header-nav-el with-dropdown');
            this.subs = this.getElementsByClassName('header-nav-sub');
            this.dropdownIsOpen = false;
            body.addEventListener('click', this.listenClick.bind(this));
        }
        listenClick(e) {
            this.realTarget = null;
            this.eTarget = 'else';
            for (let i=0; i<this.subs.length; i++) {
                if (isChildOf(e.target, this.elsWithDropdown[i])) this.eTarget = 'navEl';
                if (isChildOf(e.target, this.subs[i])) this.eTarget = 'sub';
            }
            if (this.eTarget == 'navEl') {
                if (e.target.classList.contains('header-nav-el')) this.realTarget = e.target;
                else this.realTarget = e.target.closest('.header-nav-el');
                if (isActive(this.realTarget)) unsetActive(this.realTarget);
                else {
                    this.closeAllSubs();
                    setActive(this.realTarget);
                }
            } else {
                if (this.eTarget == 'else') this.closeAllSubs();
            }
        }
        closeAllSubs() {
            for (let i=0; i<this.elsWithDropdown.length; i++) {
                unsetActive(this.elsWithDropdown[i]);
            }
        }
    }
    customElements.define('nav-desktop', nav);
    class collapisble extends HTMLElement {
        constructor() {
            super();
            this.toggler = this.getElementsByClassName('collapsible-toggler')[0];
            this.outer = this.getElementsByClassName('collapsible-content-outer')[0];
            this.content = this.getElementsByClassName('collapsible-content')[0];
            this.toggler.addEventListener('click', this.toggle.bind(this));

            if(isActive(this)) this.defaultActive();
        }
        toggle() {
            if (isActive(this)) {
                unsetActive(this);
                this.outer.style.height = "0";
            } else {
                setActive(this);
                this.height = this.content.getBoundingClientRect().height;
                this.outer.style.height = this.height + "px";
            }
        }

        defaultActive(){
            this.height = this.content.getBoundingClientRect().height;
            this.outer.style.height = this.height + "px";
        }
    }
    customElements.define('collapsible-table', collapisble);
    class readMore extends HTMLElement {
        constructor(){
            super();

            this.btn = this.querySelector('.read-more-btn');
            this.outer = this.querySelector('read-more-outer');
            this.content = this.querySelector('.read-more-content');
            this.contentInner = this.querySelector('.read-more-content-inner');

            if(this.content.getBoundingClientRect().height >= this.contentInner.getBoundingClientRect().height){
                this.btn.style.display = 'none';
                this.content.style.height = 'unset';
            }

            this.btn.addEventListener('click', this.collapse.bind(this));
        }

        collapse () {
            this.content.style.height = this.contentInner.getBoundingClientRect().height + 'px';
            this.btn.style.display = 'none';
        }
    }
    customElements.define('read-more', readMore);
    class openPopup extends HTMLElement {
        constructor() {
            super();

            this.url = this.dataset.url;

            this.addEventListener('click', this.open.bind(this));
        }
        
        async open (e) {

            e.preventDefault();
            popup.open();

            fetch(this.url)
                .then((response) => response.text())
                .then(responseText => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    const source = html.querySelector('.pop-up-inner');
                    popup.load(source);
                    init(popup.outer);
                })

            if(this.url.includes('quick-view')){
                addProductToViewed(this.dataset.product);
            }
        }
    }
    customElements.define('open-popup', openPopup);
    class discountGroup extends HTMLElement{
        constructor() {
            super();

            this.btn = this.querySelector('.discount-group-btn');

            this.btn.addEventListener('click', this.apply.bind(this));

        }

        apply (e) {
            e.preventDefault();

            this.code = this.querySelector('.discount-group-code').value;
            setActive(this.btn);

            fetch(`/discount/${this.code}`)
                .then(() => {
                    window.cdGrab();
                    unsetActive(this.btn);
                    setActive(this);
                    localStorage.setItem('discount', this.code);
                })
        }
    }
    customElements.define('discount-group', discountGroup);
    class quantityInput extends HTMLElement{
        constructor(){
            super();
    
            this.plus = this.querySelector('[quantity-plus]');
            this.minus = this.querySelector('[quantity-minus]');
            this.input = this.querySelector('[quantity-input]');
            this.display = this.querySelector('[quantity-display]');
    
            this.value = this.input.value;
    
            if(!this.plus || !this.minus || !this.input) return;
    
            this.plus.addEventListener('click', () => this.onPlus());
            this.minus.addEventListener('click', () => this.onMinus());
        }
    
        onPlus () {
            if(this.value >= 9) return;
            this.value ++;
            this.input.value = this.value;
            this.display.textContent = this.value;
        }
    
        onMinus () {
            if(this.value <= 0) return;
            this.value --;
            this.input.value = this.value;
            this.display.textContent = this.value;
        }
    }
    customElements.define('quantity-input', quantityInput);
    class productForm extends HTMLElement{
        constructor () {
            super();
    
            this.forms = this.querySelectorAll('form[action="/cart/add"]');

            if(!this.forms.length === 0) return;
    
            this.forms.forEach(form => {
                form.addEventListener('submit', (e) => this.onSubmit(e, form));
            })
        }
    
        async onSubmit(e, form){
            e.preventDefault();
            AddToCart(form);
            if(this.closest('.pop-up-inner')) popup.close();
        }
    }
    customElements.define('product-form', productForm);

    popup.initialize();
    search.initialize();
    newsletter.initialize();
    init(document);

    const lozadObs = lozad();
    lozadObs.observe();

    document.addEventListener('click', (e) => {
        if(parentContainsClass(e.target, 'nav-mobile-toggler', 5)) toggleNM();
        else if(parentContainsClass(e.target, 'nav-mobile-closer', 5)) closeNM();
        else if(parentContainsClass(e.target, 'nav-mobile-opener', 5)) openNM();
    })

}, { passive: true })

function replaceRteLi (container){
    var rteLiSvg = document.querySelector('.rte-li-svg').children[0];
    if(rteLiSvg){
        const li = container.querySelectorAll('.rte ul li');
        li.forEach((li) => {

            if(li.closest('.rte').querySelector('.local-rte-li-svg')){
                rteLiSvg = li.closest('.rte').querySelector('.local-rte-li-svg').children[0];
            }

            for(i=0;i<li.children.length;i++) if(li.children[i].tagName == 'svg') return;
            var span = document.createElement('span');
            var svg = rteLiSvg.cloneNode(true);
            span.innerHTML = li.innerHTML;
            li.innerHTML = '';
            li.appendChild(svg);
            li.appendChild(span);
        });
    }
}

function removeRte (container){
    const rtes = container.querySelectorAll('.rte');
    rtes.forEach(rte => {
        const metas = rte.querySelectorAll('meta');
        metas.forEach(meta => {
            meta.remove();
        })
    })
}

let docIsInit = false;
function init (container) {
    replaceRteLi(container);
    removeRte(container);

    if(docIsInit){
        try{ jdgm.customizeBadges(); }
        catch(error){ console.warn(error); }
    }

    docIsInit = true;
}

function setActive(element) {
    if (element) element.classList.add('active');
}

function unsetActive(element) {
    if (element) element.classList.remove('active');
}

function toggleActive(el) {
    if (el) el.classList.toggle('active');
}

function isActive(el) {
    if (el) {
        for (i = 0; i < el.classList.length; i++) {
            if (el.classList[i] == 'active') return true;
        }
        return false;
    }
}

function parentContainsClass (el, cl, iteration = 3){
    if(el.classList.length > 0 && el.classList.contains(cl)) return true;
    var child = el;
    for(i=0;i<iteration;i++){
        if(child.parentElement && child.parentElement.classList.length > 0 && child.parentElement.classList.contains(cl)) return true;
        if(child.parentElement) child = child.parentElement;
    }
    return false;
}

function isChild (child, parent){
    if(child.closest(parent)) return true;
    return false;
}

function isChildOf(child, parent) {
    if (parent.contains(child))
        return true;
    return false;
}

let cd;

function AddToCart(form) {
    cartDrawer.open();
    cd.classList.add('is-loading');
    let formData = new FormData(form);
    fetch('/cart/add.js', {
        method: 'POST',
        body: formData
    })
        .then(() => {
            window.cdGrab();
        })
}


const popup = {

    initialize: function () {
        this.outer = document.querySelector('.pop-up-outer');
        if(!this.outer) return;

        let closer = this.outer.querySelector('.pop-up-closer');
        let bg = this.outer.querySelector('.pop-up-bg');
        this.container = this.outer.querySelector('.pop-up-inner');
        this.emptyContent = this.container.innerHTML;

        if(closer) closer.addEventListener('click', this.close.bind(this));
        if(bg) bg.addEventListener('click', this.close.bind(this));
    },

    load: function (content) {
        if (typeof content === 'string'){
            this.container.innerHTML = content;
        }
        else if (content instanceof HTMLElement){
            this.container.innerHTML = content.innerHTML;
        }
        this.outer.classList.remove('is-empty');
    },

    close: function () {
        unsetActive(this.outer);
        body.classList.remove('menu-open');
        this.container.innerHTML = this.emptyContent;
        this.outer.classList.add('is-empty');
    },

    open: function () {
        setActive(this.outer);
        body.classList.add('menu-open');
    }

}

const search = {
    initialize: function () {
        let searchTogglers = document.querySelectorAll('.header-icon-search');
        let searchClosers = document.querySelectorAll('.header-search-close');

        if(searchTogglers.length > 0){
            searchTogglers.forEach((el) => {
                el.addEventListener('click', (e) => { this.toggle(e); })
            })
        }
        if(searchClosers.length > 0){
            searchClosers.forEach((el) => {
                el.addEventListener('click', (e) => { this.close(e); })
            })
        }
    },

    toggle: function (e){
        let modal = e.currentTarget.closest('header').querySelector('.header-search');
        if(modal) toggleActive(modal);
    },

    close: function (e){
        let modal = e.currentTarget.closest('header').querySelector('.header-search');
        if(modal) unsetActive(modal);
    }
}

const newsletter = {
    initialize: function () {
        let opener = document.querySelector('.header-icon-newsletter');
        let klaviyoId = document.querySelector('.header-newsletter-klaviyo-id')?.value;

        if(opener && klaviyoId) opener.addEventListener('click', () => {
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', klaviyoId]);
        });
    }
}

Shopify.formatMoney = function (cents) {
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = window.money_format;

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
        case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
        case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
        case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
}

function addProductToViewed(product){
    let viewedProducts = localStorage.getItem('viewedProducts');
    viewedProducts = viewedProducts ? JSON.parse(viewedProducts) : [];

    if (!viewedProducts.includes(product)) {
        viewedProducts.unshift(product);

        if (viewedProducts.length > 8) {
            viewedProducts.pop();
        }
    } else{
        const index = viewedProducts.indexOf(product);
        if(index !== -1){
            viewedProducts.splice(index, 1);
            viewedProducts.unshift(product);
        }
    }

    localStorage.setItem('viewedProducts', JSON.stringify(viewedProducts));
}

class upsell extends HTMLElement {
    constructor () {
        super ();
        
        this.toggle = this.querySelector('.toggle');

        this.toggle.addEventListener('click', this.onClick.bind(this));
    }

    onClick () {
        if(this.toggle.dataset.action == 'add') this.add();
        else this.remove();
    }

    add () {
        this.classList.add('loading');

        let formData = {
            'items': [{
                'id': this.dataset.variant,
                'quantity': 1
            }]
        };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(() => {
                window.cdGrab();
            })
            .then(() => {
                this.toggle.dataset.action = 'remove';
                this.classList.remove('loading');
            })
    }

    remove () {
        this.classList.add('loading');

        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ quantity: 0, id: this.dataset.variant })
        })
            .then(() => {
                window.cdGrab();
            })
            .then(() => {
                this.toggle.dataset.action = 'add';
                this.classList.remove('loading');
            })
    }
}
customElements.define('upsell-el', upsell);